export const DETECTION_TYPES = {
  FACES: 'FACES',
  BODIES: 'BODIES',
};
